module.exports = __webpack_public_path__ + "img/大理国际入口.72026fa2.png";